<template lang='pug'>
  .text-center
    div(:class='numberClass') {{number}}
    .text-caption.grey--text {{label}}
</template>

<script>
export default {
  name: 'BionicMetricsNumber',
  components: {},
  props: ['number', 'label', 'number-class'],
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .numberCircle {
    border-radius: 50%;
    width: 100px;
    height: 100px;
    padding: 20px;
    margin: auto;
    background: #607D8B;
    border: 2px solid #607D8B;
    color: #FFFFFF;
  }
</style>
